export interface SetIframeOptions {
   disableIframeAllowConfig?: boolean,
   disableIframeSandboxConfig?: boolean
}
